import React, { Component } from 'react'
import classnames from 'classnames'
import Header from './header'
import Carousel from './carousel'
import Box from './box'
import Cart from './cart'
import Notif from './notif'
import { getUrlParamByName, removeUrlParams } from './../libs/url.js'

class App extends Component {
  state = {
    item: {
      id: 1,
      title: 'Midtrans Pillow',
      price: 20000,
      desc: 'Get cozy with our new pillow!',
      previews: [
        `./images/slide/1.jpg`,
        `./images/slide/2.jpg`,
        `./images/slide/3.jpg`,
        `./images/slide/4.jpg`
      ]
    },
    cartItems: [],
    buying: false,
    checkout: false,
    settings: false,
    notif: {
      show: false,
      type: ''
    }
  }

  componentWillMount() {
    const orderId = getUrlParamByName('order_id');
    const statusCode = getUrlParamByName('status_code');
    const transactionStatus = getUrlParamByName('transaction_status');
    if (orderId && statusCode && transactionStatus) {
      const transactionTypes = {
        capture: 'success',
        authorize: 'success',
        pending: 'pending',
        error: 'error',
        deny: 'error'
      }

      this.onResult({type: transactionTypes[transactionStatus]})

      removeUrlParams();

    }

  }

  _onBuy = (item) => {
    let cartItems = this.state.cartItems
    cartItems.push(item)

    this.setState({
      cartItems: cartItems,
      buying: true
    })
  }

  _onSettings = (open) => {
    this.setState({
      settings: open
    })
  }

  _onCheckout = () => {
    this.setState({checkout: true})
  }

  _onCancel = () => {
    this.setState({
      cartItems: [],
      buying: false,
      checkout: false
    })
  }

  _onResult = (result) => {
    this.setState({
      notif: {
        show: true,
        type: result.type
      },
      checkout: false
    })
  }

  _closeNotif = () => {
    this.setState({
      notif: {
        show: false,
        type: ''
      }
    })
  }

  _onPriceChange = (newPrice) => {
    let item = this.state.item;
    item.price = newPrice;
    this.setState({ item });
  }

  render () {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className={classnames('main-content', {'buying': this.state.buying})}>
            <Header/>
            <Carousel item={this.state.item}/>
            <div className="ss-box-wrapper">
              <div className="ss-box">
                <Box item={this.state.item} onBuy={this._onBuy} showSignUp={!this.state.checkout}/>
                <Notif {...this.state.notif} onRequestClose={this._closeNotif}/>
              </div>
            </div>
            <div className={classnames('main-overlay', {'buying': this.state.buying && !this.state.settings})}></div>
            <div className={classnames('btn-signup-overlay-wrapper', {'hide': !this.state.checkout})}>
              <a className="btn-signup-overlay" href="https://account.midtrans.com/register" target="_blank">
                SIGN UP to MIDTRANS &rarr;
              </a>
            </div>
          </div>
          <Cart
            className={classnames('cart-content', {'buying': this.state.buying})}
            items={this.state.cartItems}
            onPriceChange={this._onPriceChange}
            onCancel={this._onCancel}
            onResult={this._onResult}
            onSettings={this._onSettings}
            onCheckout={this._onCheckout}/>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/components/app.jsx